var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "141px",
    height: "140px",
    viewBox: "0 0 141 140",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "symbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00_NFT_landing_1920",
    transform: "translate(-1146.000000, -2593.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 4,
    transform: "translate(339.121661, 2311.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbol",
    transform: "translate(806.878339, 282.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4283335,0.153419071 C115.974355,5.97443791 140.886189,35.190012 140.886189,69.5569055 C140.886189,88.71521 133.187884,106.676352 119.785996,119.831252 C115.751854,123.791048 109.271487,123.730778 105.311691,119.696637 C101.351896,115.662495 101.412165,109.182128 105.446307,105.222332 C113.689308,97.1312445 118.880911,86.5123767 120.124934,74.9760106 L90.9130945,74.975 L90.9137373,86.415082 C90.9137373,92.0029191 86.4359674,96.544917 80.8729109,96.6485924 L80.6784159,96.6504034 C75.0905788,96.6504034 70.5485809,92.1726335 70.4449054,86.609577 L70.4430945,86.415082 L70.4430945,10.2380407 C70.4430945,7.67139455 71.3779085,5.3552058 72.9049636,3.57772221 L73.1384209,3.31517599 C75.3976483,0.860054233 78.8247135,-0.47189322 82.4283335,0.153419071 Z M90.9131352,24.0009355 L90.9130945,54.504 L118.085576,54.5042283 C113.811256,41.0591941 103.963777,29.9587962 91.1161638,24.09189 L90.9131352,24.0009355 Z",
    id: "Combined-Shape",
    fill: "#11FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4243757,4.484368 C48.6443088,2.31490235 54.6346001,4.78779481 56.8040657,10.0077279 C58.9480083,15.16625 56.5581821,21.0771108 51.463795,23.3092695 L51.2807058,23.3874179 C32.7805179,31.0763138 20.4706428,49.1775147 20.4706428,69.5569055 C20.4706428,97.1559285 42.8440715,119.529357 70.4430945,119.529357 C73.5674649,119.529357 76.6499273,119.243888 79.6662262,118.681827 L80.3115544,118.557155 C85.8545271,117.44822 91.2469635,121.042718 92.3558983,126.585691 C93.464833,132.128664 89.870335,137.5211 84.3273623,138.630035 C79.7854498,139.538696 75.1409279,140 70.4430945,140 C31.5384477,140 0,108.461552 0,69.5569055 C0,40.8350646 17.351296,15.3206469 43.4243757,4.484368 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo-sm.bd885e187240f0c031ecb75e737bda11.svg";
export { ForwardRef as ReactComponent };